import { pageNavNumsGet } from "common/search/search_common";
import React from "react";
import styled from "styled-components";

type SearchNavigationProps = {
  totalCount: number;
  skip: number;
  limit: number;
  navAct?: (skip: number) => void;
};

const SearchNavigation: React.FC<SearchNavigationProps> = ({
  totalCount,
  skip,
  limit,
  navAct,
}: SearchNavigationProps) => {
  const { currentPage, pageCount } = pageNavNumsGet(limit, skip, totalCount);
  const liNav = (pageNum: number) => {
    if (navAct && pageNum >= 1 && pageNum <= pageCount) {
      const newSkip = (pageNum - 1) * limit;
      navAct(newSkip);
    }
  };

  return (
    <div>
      <Div>Ukupno: {totalCount}</Div>
      <Div>
        <Nav onClick={() => liNav(1)}>&lt;&lt;</Nav>
        <Nav onClick={() => liNav(currentPage - 1)}>&lt;</Nav>
        <Nav onClick={() => liNav(currentPage + 1)}>&gt;</Nav>
        <Nav onClick={() => liNav(pageCount)}>&gt;&gt;</Nav>
        <NumShow>{currentPage}</NumShow>
        <NumShow>/</NumShow>
        <NumShow>{pageCount}</NumShow>
      </Div>
    </div>
  );
};

const Div = styled.div`
  margin-top: ${(props) => props.theme.spacing.l};
`;

const Nav = styled.span`
  margin-left: ${(props) => props.theme.spacing.l};
  cursor: pointer;
`;

const NumShow = styled.span`
  margin-left: ${(props) => props.theme.spacing.m};
`;

export default SearchNavigation;
